import { AdminBaseService } from "lib/service/client/AdminBaseService";
import { ErrorV2, Result } from "lib/service/BaseClientService";

export class AdminIntegrationJtbService extends AdminBaseService {
  constructor(adminType: string) {
    super(adminType);
    this.url = `${this.url}/page/integration/jtb`;
  }

  async getTargetProjects(): Promise<Result<JtbTargetProjectsOutput, ErrorV2>> {
    return super.doSearch<JtbTargetProjectsOutput, ErrorV2>(`${this.url}/target_projects`);
  }

  async getSettings(projectId: number): Promise<Result<JtbSettingsOutput, ErrorV2>> {
    return super.doGet<JtbSettingsOutput, ErrorV2>(`${this.url}/${projectId}`, "settings");
  }

  async postProductMapping(projectId: number, input: ProductMappingPostInput): Promise<Result<void, ErrorV2>> {
    const body = JSON.stringify(input)
    return super.doPost(`${this.url}/${projectId}/product_mapping`, body)
  }
}

export type JtbTargetProjectsOutput = {
  id: number;
  title: string;
}[]
export type JtbSettingsOutput = {
  product_mapping_groups: ProductMappingGroup[]
}
export type ProductMappingGroup = {
  course_id: number;
  course_name: string;
  questions: string[];
  product_mappings: ProductMapping[]
}
export type ProductMapping = {
  mapping_key: string[];
  product_code: string;
}
export type ProductMappingPostInput = {
  course_id: number;
  course_name: string;
  questions: string[];
  product_mappings: ProductMapping[]
}
